<template>
    <div class="booklist-details" ref="main">
        <!-- 路由 -->
        <div class="router-container">
            <router-link class="router-item" to="/read/readIndex">
                <span>首页</span>
            </router-link>/
            <router-link class="router-item" to="/read/themeBook">
                <span>主题书单</span>
            </router-link>/
            <div>
                <span>{{ themeInfoAgg.title }}</span>
            </div>
        </div>

        <!-- :style="themeInfoAgg.logoPath
            ? { backgroundImage: `url(${themeInfoAgg.logoPath})` }
            : null" -->
        <!-- 头部横幅 -->
        <div class="header-banner" >
            <div class="banner-overlay">
                <div class="banner-content">
                    <div class="banner-text">
                        <h1>{{ themeInfoAgg.title }}</h1>
                        <p>这是一段关于父子关系的详细描述文字，讲述了父亲与儿子之间深刻的情感纽带和相互影响。通过阅读这本书，我们可以更好地理解家庭关系的重要性。</p>
                        <div class="dateItem">
                            <img src="../../assets/readimg/date.svg" alt="">
                            <span>2024.01.18</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main-content">
            <div class="booklist-details-header">
                <!-- 电子书部分 -->
                <div class="content-section" id="ebook" v-if="themeInfoAgg.relaCount.bookCount > 0">
                    <div class="section-header">
                        <h2>电子书</h2>
                        <div class="pagination">
                            
                            <div class="nav-buttons">
                                <button class="nav-btn" @click="prevPage('ebook')" :disabled="ebooksData.pageIndex === 0">&lt;</button>
                                <span>{{ ebooksData.pageIndex + 1 }} / {{ Math.ceil(ebooksData.total / ebooksData.pageSize) }}</span>
                                <button class="nav-btn" @click="nextPage('ebook')" :disabled="ebooksData.pageIndex >= Math.ceil(ebooksData.total / ebooksData.pageSize) - 1">&gt;</button>
                            </div>
                        </div>
                    </div>
                    <div class="books-container">
                        <div class="book-card" v-for="(book, index) in ebooksData.list" :key="index">
                            <div class="book-cover" @click="AudtlDetail(book)">
                                <img :src="prefix + 'ui/draftBook/getCover?multimediaID=' + book.source.logoID" alt="" @error="handleBookError" class="image-placeholder">
                            </div>
                            <div class="book-info">
                                <h3 class="title" :title="book.source.title" @click="AudtlDetail(book)">{{ book.source.title }}</h3>
                                <p class="author" :title="book.source.authors">{{ book.source.authors }}</p>
                                <div class="book-stats">
                                    <div class="stat-item">
                                        <img src="../../assets/readimg/read.svg" alt="">
                                        <span>{{ book.source.viewCount }}读过</span>
                                    </div>
                                </div>
                            </div>
                            <button class="read-btn" @click="readBook(book)">开始阅读</button>

                        </div>
                    </div>
                </div>

                <!-- 有声书部分 -->
                <div class="content-section" id="audiobook" v-if="themeInfoAgg.relaCount.audioCount > 0">
                    <div class="section-header">
                        <h2>有声书</h2>
                        <div class="pagination">
                            <div class="nav-buttons">
                                <button class="nav-btn" @click="prevPage('audiobook')" :disabled="audiobooksData.pageIndex === 0">&lt;</button>
                                <span>{{ audiobooksData.pageIndex + 1 }} / {{ Math.ceil(audiobooksData.total / audiobooksData.pageSize) }}</span>
                                <button class="nav-btn" @click="nextPage('audiobook')" :disabled="audiobooksData.pageIndex >= Math.ceil(audiobooksData.total / audiobooksData.pageSize) - 1">&gt;</button>
                            </div>
                        </div>
                    </div>
                    <div class="books-container">
                        <div class="book-card" v-for="(book, index) in audiobooksData.list" :key="index">
                            <div class="book-cover" @click="Audtl(book)">
                                <img  :src="book.source.imgUrlCompressed" alt="" class="image-placeholder" @error="handleError">
                            </div>
                            <div class="book-info">
                                <h3 class="title" :title="book.source.title" @click="Audtl(book)">{{ book.source.title }}</h3>
                                <p class="author" :title="book.source.authors">{{ book.source.authors }}</p>
                                <div class="book-stats">
                                    <div class="stat-item">
                                        <img src="../../assets/readimg/ear.svg" alt="">
                                        <span>{{ book.source.viewCount }}</span>
                                    </div>
                                </div>
                                <button class="listen-btn" @click="Audtl(book)">开始听书</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 课程部分 -->
                <div class="content-section" id="course"  v-if="themeInfoAgg.relaCount.videoCount > 0">
                    <div class="section-header">
                        <h2>课程</h2>
                        <div class="pagination">
                            
                            <div class="nav-buttons">
                                <button class="nav-btn" @click="prevPage('course')" :disabled="coursesData.pageIndex === 0">&lt;</button>
                                <span>{{ coursesData.pageIndex + 1 }} / {{ Math.ceil(coursesData.total / coursesData.pageSize) }}</span>
                                <button class="nav-btn" @click="nextPage('course')" :disabled="coursesData.pageIndex >= Math.ceil(coursesData.total / coursesData.pageSize) - 1">&gt;</button>
                            </div>
                        </div>
                    </div>
                    <div class="courses-grid">
                        <div class="course-card" v-for="(course, index) in coursesData.list" :key="index" @click="couraudio(course)">
                            <div class="course-image">
                                <img :src="course.source.imgUrlCompressed" alt="" class="image-placeholder">

                            </div>
                            <div class="course-info">
                                <h3 :title="course.source.title">{{ course.source.title }}</h3>
                                <p class="instructor" :title="course.source.instructor">{{ course.source.instructor }}</p>
                                <div class="course-stats">
                                    <div class="stat-item">
                                        <img src="../../assets/readimg/clocks.svg" alt="">
                                        <span>{{ course.source.viewCount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>

            <!-- 右侧固定导航 -->
            <div class="fixed-sidebar">
                <div class="sidebar-content">
                    <div class="nav-item-title">
                        <span>书单目录</span>
                    </div>
                    <div class="nav-item" :class="{ active: activeSection === 'ebook' }" @click="scrollToSection('ebook')" v-if="themeInfoAgg.relaCount.bookCount > 0">
                        <div class="nav-icon">
                            <img src="../../assets/readimg/read_1.svg" alt="">
                        </div>
                        <div class="nav-item-text">
                            <p class="title">电子书</p>
                            <p class="num">{{themeInfoAgg.relaCount.bookCount}}本</p>
                        </div>
                    </div>
                    <div class="nav-item" :class="{ active: activeSection === 'audiobook' }" @click="scrollToSection('audiobook')" v-if="themeInfoAgg.relaCount.audioCount > 0">
                        <div class="nav-icon">
                            <img src="../../assets/readimg/ear.svg" alt="">
                            </div>
                            <div class="nav-item-text">
                                <p class="title">有声书</p>
                                <p class="num">{{themeInfoAgg.relaCount.audioCount}}本</p>
                            </div>
                    </div>
                    <div class="nav-item" :class="{ active: activeSection === 'course' }" @click="scrollToSection('course')" v-if="themeInfoAgg.relaCount.videoCount > 0">
                        <div class="nav-icon">
                            <img src="../../assets/readimg/course.svg" alt="">
                        </div>
                        <div class="nav-item-text">
                            <p class="title">课程</p>
                            <p class="num">{{themeInfoAgg.relaCount.videoCount}}本</p>
                        </div>
                    </div>
                    <button class="join-btn" @click="yunAdd()" :style="shelfStatus?'background:#cbcbcb;color:#7b7b7b':''">{{shelfStatus ? '移出书架' : '加入书架'}}</button>
                </div>
            </div>
        </div>
        <!-- 热门专题推荐 -->
        <div class="content-section" v-if="topics.length>0">
            <div class="section-header">
                <h2>热门专题推荐</h2>
            </div>
            <div class="topics-container">
                <div class="topic-card" v-for="(topic, index) in topics" :key="index" @click="updatebook(topic)">
                    <div class="topic-image">
                        <img :src="topic.imgUrl" alt="" @error="handleError" class="image-placeholder">
                    </div>
                    <div class="topic-overlay">
                        <h3>{{ topic.groupName }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/index.js';
import defaultImg1 from '@/assets/readimg/defaultImg1.png';
import defaultImg2 from '@/assets/readimg/defaultImg2.png';
export default {
    name: 'booklistDetails',
    data() {
        return {
            activeSection: 'ebook', // 当前激活的导航项
            prefix: this.prefix,
            ebooksData:{
                list:[],
                total:0,
                pageSize:3,
                pageIndex:0
            },
            audiobooksData:{
                list:[],
                total:0,
                pageSize:3,
                pageIndex:0
            },
            coursesData:{
                list:[],
                total:0,
                pageSize:4,
                pageIndex:0
            },
            topics: [],
            themeInfoAgg: {
                title:'',
                relaCount:{
                    bookCount:0,
                    audioCount:0,
                    courseCount:0
                }
            },
            shelfStatus:false,
            shelfID: '',
        }
    },
    props: {
        parentScrollRef: {  // 父组件传递的滚动容器ref名称
            type: String,
            default: 'main'
        }
    },
    beforeRouteUpdate(to, from, next) {
        // 路由更新时判断id是否变化
        if (to.query.id !== from.query.id) {
            // id改变时，滚动到顶部
            this.ebooksData.pageIndex = 0
            this.ebooksData.pageSize = 3
            this.audiobooksData.pageIndex = 0
            this.audiobooksData.pageSize = 3
            this.coursesData.pageIndex = 0
            this.coursesData.pageSize = 4
            this.scrollParentToTop()
        }
        // 继续更新路由
        next()
    },
    mounted() {
        this.themeInfoRight();
        this.themelistInfo();
        this.themeHotTopic();
        this.scrollParentToTop()

    },
    
    methods: {
        scrollParentToTop() {
            // 1. 获取父组件的滚动容器DOM
            const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!parentScrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref是否正确');
                return;
            }
            parentScrollContainer.scrollTop = 0;
        },
        handleError(e){
            if(this.params.type  ==='eBook'){
                e.target.src = `${this.imageDomainNew}images/default1.png`
            }else if(this.params.type  ==='audioBook'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }else if(this.params.type  ==='course'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }
        },
        async themeInfoRight(){
            try{
                let res = await api.themeInfoAggRes({
                    ID: this.$route.query.bookListID,
                    bookListID: this.$route.query.id
                })
                if(res.data.status == 1){
                    this.themeInfoAgg = res.data.data;
                    this.shelfStatus = res.data.data.shelfStatus;
                    this.shelfID = res.data.data.shelfID
                }
            }catch(error){
                this.$message.error(error.message);
            }
        },
        async fetchThemeData(pageIndex = 0, pageSize = 3, type, property) {
            try {
                const res = await api.themeListInfo({
                    ID: this.$route.query.bookListID,
                    bookListID: this.$route.query.id,
                    pageIndex,
                    pageSize,
                    type
                });
                
                if (res.data.status === 1) {
                    this[property].list = res.data.data.hits;
                    this[property].total = res.data.data.total;
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async themelistInfo() {
            await Promise.all([
                this.fetchThemeData(this.ebooksData.pageIndex, this.ebooksData.pageSize, 1 ,'ebooksData'),
                this.fetchThemeData(this.audiobooksData.pageIndex, this.audiobooksData.pageSize, 3 , 'audiobooksData'),
                this.fetchThemeData(this.coursesData.pageIndex, this.coursesData.pageSize, 4, 'coursesData')  // 课程使用pageSize=4
            ]);
        },
        async themeHotTopic(){
            try{
                let res = await api.themeHotTopic({
                    pageIndex: 0,
                    pageSize: 3
                })
                if(res.data.status == 1){
                    this.topics = res.data.data;
                }
            }catch(error){
                this.$message.error(error.message);
            }
        },
        handleBookError(e){
            e.target.src = defaultImg2;
        },
        // 滚动到指定区域
        scrollToSection(section) {
            this.activeSection = section;
            
            const targetElement = document.getElementById(section);
            if (targetElement) {
                const offset = 100; // 偏移量
                const top = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
        },
        
        // 分页方法
        async prevPage(type) {
            let dataProperty, apiType;
            
            switch(type) {
                case 'ebook':
                    dataProperty = 'ebooksData';
                    apiType = 1;
                    break;
                case 'audiobook':
                    dataProperty = 'audiobooksData';
                    apiType = 3;
                    break;
                case 'course':
                    dataProperty = 'coursesData';
                    apiType = 4;
                    break;
                default:
                    return;
            }
            
            if (this[dataProperty].pageIndex > 0) {
                this[dataProperty].pageIndex--;
                await this.fetchThemeData(this[dataProperty].pageIndex, this[dataProperty].pageSize, apiType, dataProperty);
            }
        },
        
        async nextPage(type) {
            let dataProperty, apiType;
            
            switch(type) {
                case 'ebook':
                    dataProperty = 'ebooksData';
                    apiType = 1;
                    break;
                case 'audiobook':
                    dataProperty = 'audiobooksData';
                    apiType = 3;
                    break;
                case 'course':
                    dataProperty = 'coursesData';
                    apiType = 4;
                    break;
                default:
                    return;
            }
            
            const maxPage = Math.ceil(this[dataProperty].total / this[dataProperty].pageSize) - 1;
            if (this[dataProperty].pageIndex < maxPage) {
                this[dataProperty].pageIndex++;
                await this.fetchThemeData(this[dataProperty].pageIndex, this[dataProperty].pageSize, apiType, dataProperty);
            }
        },
        readBook(book){
            let url = "/read/ebookrdr";
            let query = {
                bookid: book.source.sourceBookInfoID,
                // uuid: uuid,
                // chapterid: chapterid,
                type: 'epub',
                detailUrl: encodeURIComponent(window.location.href)
            };
            let routeUrl = this.$router.resolve({
                path: url,
                query: query
            });
            window.open(routeUrl.href, "_blank");
        },
        updatebook(item){
            this.$router.push({
                path: '/read/booklistDetails',
                query: {
                    id: item.ID,
                    bookListID: item.groupID,
                }
            })
        },
        //加入书架
        async fetchaddShelf(){
            try {
                const res = await api.fetchaddShelf({
                    groupID: this.$route.query.bookListID,bookListID: this.$route.query.id
                });
                
                if (res.data.status === 1) {
                    this.shelfStatus = true
					this.shelfID = res.data.shelfID
                    this.$message({
                        message: res.data.message,
                        type: 'success',
                        duration: 1000
                    });
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //移除书架
        async yunDel(){
            try {
                const res = await api.fetchDelShelf({
                    id: this.shelfID
                });
                if (res.data.status === 1) {
                    this.shelfStatus = false
                    this.$message({
                        message: res.data.message,
                        type: 'success',
                        duration: 1000
                    });
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        yunAdd(){
            if(this.shelfStatus){
                this.yunDel()
            }else{
                this.fetchaddShelf()
            }
        },
        couraudio(item){
            this.$router.push({
                path: '/couraudio',
                query: {
                    id: item.source.sourceID,
                }
            })
        },
        Audtl(item){
            this.$router.push({
                path: '/Audtl',
                query: {
                    id: item.source.sourceID,
                }
            })
        },
        AudtlDetail(item){
            this.$router.push({
            path: '/ebookdtl',
            query: {
                id: item.source.sourceBookInfoID,
            }
        })
        }
        
    },
    watch:{
        '$route.query.id': {
            handler(newId, oldId) {
                if (newId !== oldId) {
                    this.themeInfoRight();
                    this.themelistInfo();
                    this.themeHotTopic();
                }
            },
            immediate: false
        }
    }
}
</script>

<style lang="scss" scoped>
.booklist-details {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    background: #f7f7f7;
    position: relative;
}

.router-container{
    display: flex;
    gap: 10px;
    margin: 16px 0;
    font-size: 12px;
    color: #666;
    .router-item{
        cursor: pointer;
        color: #666;
    }
}

// 头部横幅
.header-banner {
    height: 400px;
    // background: rgba(0, 0, 0, 0.3);
    position: relative;
    margin-bottom: 40px;
    margin-top: 16px;
    border-radius: 12px;
    background-size: cover;
    background-position: center;
    background: url(../../assets/image/ztxq.png) no-repeat;
    .banner-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        padding: 0 20px;
        
        .banner-content {
            max-width: 600px;
            
            .banner-text {
                padding: 40px;
                border-radius: 8px;
                
                h1 {
                    font-size: 28px;
                    margin: 0 0 20px 0;
                    color: #333;
                    line-height: 1.4;
                }
                
                p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #666;
                    margin: 0 0 20px 0;
                }
                
                .dateItem {
                    font-size: 14px;
                    color: #666;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    img{
                        width: 16px;
                        height: 16px;
                        object-fit: contain;
                    }
                }
            }
        }
    }
}

// 右侧固定导航
.fixed-sidebar {
    width: 2.5rem;
    z-index: 100;
    
    .sidebar-content {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        padding: 20px;

        .nav-item-title {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
            font-weight: 600;
        }
        
        .nav-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 15px 10px;
            cursor: pointer;
            border-radius: 8px;
            background: #fafafa;
            margin-bottom: 10px;

            &.active {
                background: #FDF3F3;
            }

            &:last-of-type {
                border-bottom: none;
            }
            
            .nav-icon {
                width: 40px;
                height: 40px;
                padding: 10px;
                background: #F6E3E3;
                border-radius: 10px;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            
            .nav-item-text{
                font-size: 14px;
                color: #333;

                .num{
                    font-size: 11px;
                }
            }
        }

        
        .join-btn {
            width: 100%;
            background: #e6564e;
            color: white;
            border: none;
            padding: 12px;
            border-radius: 6px;
            font-size: 14px;
            cursor: pointer;
            margin-top: 20px;
        }
    }
}

// 主要内容区域
.main-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px 40px;
    display: flex;
    flex-direction: row;
    gap: 20px;

    .booklist-details-header{
        flex: 1;

        // 内容区块
        .content-section {
            margin-bottom: 30px;
            
            .section-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 30px;
                
                h2 {
                    font-size: 24px;
                    margin: 0;
                    color: #333;
                }
                
                .pagination {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    
                    
                    
                    .nav-buttons {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        span {
                            font-size: 14px;
                            color: #666;
                        }
                        
                        .nav-btn {
                            width: 32px;
                            height: 32px;
                            border: 1px solid #ddd;
                            background: white;
                            border-radius: 4px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
            }
        }

        // 书籍容器
        .books-container {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            
            .book-card {
                background: white;
                border-radius: 8px;
                overflow: hidden; 
                padding: 20px;
                transition: transform 0.3s ease;
                cursor: pointer;
                
                .book-cover {
                    max-height: 256px;
                    display: flex;
                    justify-content: center;
                    padding: 0 30px;
                    min-height: 256px;
                    
                    .image-placeholder {
                        width: 100%;
                        background: #ddd;
                        border-radius: 12px;
                        max-height: 100%;
                    }
                }
                
                .book-info {
                    padding: 20px;
                    
                    .title {
                        font-size: 16px;
                        margin: 0 0 8px 0;
                        color: #333;
                        //设置两行显示的height，多余省略
                        line-height: 1.6;
                        height: 1.6em;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }
                    
                    .author {
                        font-size: 14px;
                        color: #666;
                        margin: 0 0 15px 0;
                        line-height: 1.4;
                        height: 1.4em;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }
                    
                    .book-stats {
                        margin-bottom: 15px;
                        
                        .stat-item {
                            display: flex;
                            align-items: center;
                            gap: 5px;
                            
                            img{
                                width: 16px;
                                height: 16px;
                                object-fit: contain;
                            }
                            
                            span {
                                font-size: 12px;
                                color: #666;
                            }
                        }
                    }
                    
                    
                }
                .read-btn, .listen-btn {
                    width: 100%;
                    padding: 10px;
                    border: none;
                    border-radius: 8px;
                    font-size: 14px;
                    cursor: pointer;
                    background: #fafafa;
                    color: #e6564e;
                    transition: all 0.3s ease;
                }

                &:hover{
                    transform: scale(1.05);
                    transition: transform 0.3s ease;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    .read-btn, .listen-btn {
                        background: #e6564e;
                        color: white;
                        transition: all 0.3s ease;
                        
                    }
                }
            }
        }

        // 课程网格
        .courses-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            
            .course-card {
                background: white;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                padding: 20px;
                display: flex;
                cursor: pointer;
                
                .course-image {
                    width: 40%;
                    height: 200px;
                    
                    .image-placeholder {
                        // width: 100%;
                        height: 100%;
                        background: #ddd;
                        border-radius: 8px;
                    }
                }
                
                .course-info {
                    width: 60%;
                    padding: 20px;
                    
                    h3 {
                        font-size: 16px;
                        margin: 0 0 8px 0;
                        color: #333;
                    }
                    
                    .instructor {
                        font-size: 14px;
                        color: #666;
                        margin: 0 0 15px 0;
                    }
                    
                    .course-stats {
                        .stat-item {
                            display: flex;
                            align-items: center;
                            gap: 5px;
                            
                            img{
                                width: 16px;
                                height: 16px;
                            }
                            
                            span {
                                font-size: 12px;
                                color: #666;
                            }
                        }
                    }
                }
            }
        }
    }
}
// 内容区块
.content-section {
    margin-bottom: 30px;
    
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        
        h2 {
            font-size: 24px;
            margin: 0;
            color: #333;
        }
        
        .pagination {
            display: flex;
            align-items: center;
            gap: 15px;
            
            span {
                font-size: 14px;
                color: #666;
            }
            
            .nav-buttons {
                display: flex;
                gap: 10px;
                
                .nav-btn {
                    width: 32px;
                    height: 32px;
                    border: 1px solid #ddd;
                    background: white;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;


                    &:hover{
                        border: 1px solid #e6564e;
                        color: #e6564e;
                    }
                }
            }
        }
    }
}
// 热门专题推荐
.topics-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    
    .topic-card {
        position: relative;
        height: 200px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover{
            transform: scale(1.05);
            transition: transform 0.3s ease;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        .topic-image {
            width: 100%;
            height: 100%;
            
            .image-placeholder {
                // width: 100%;
                height: 100%;
                background: #ddd;
            }
        }
        
        .topic-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(transparent, rgba(0,0,0,0.7));
            color: white;
            padding: 20px;
            
            h3 {
                margin: 0;
                font-size: 18px;
            }
        }
    }
}

// 响应式设计
@media (max-width: 1200px) {
    .main-content {
        margin-right: 20px;
    }
    
    .fixed-sidebar {
        display: none;
    }
}

@media (max-width: 768px) {
    .books-container {
        grid-template-columns: 1fr;
    }
    
    .courses-grid {
        grid-template-columns: 1fr;
    }
    
    .topics-container {
        grid-template-columns: 1fr;
    }
    
    .banner-overlay {
        padding: 0 20px !important;
    }
}
</style>